
define('text!modules/reporting/segments/dataExport/createEdit/templates/email.html',[],function () { return '<strand-header class="report-recipients-title" size="small">Report Recipients</strand-header>\n<strand-input class="report-recipients" id="email" fitparent="true" placeholder="Enter comma separated email address"></strand-input>';});

